import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class SuperClipRepository extends CrudRepository {
  constructor () {
    super('core/api/superClip/')
  }

  async activate (item) {
    const data = await Repository.post(`${this.resource}activate`, item)
    return data
  }

  async show (item) {
    const data = await Repository.post(`${this.resource}show`, item)
    return data
  }

  async showAutoReply (item) {
    const data = await Repository.post(`${this.resource}autoReply/show`, item)
    return data
  }

  async activateAutoReply (item) {
    const data = await Repository.post(`${this.resource}autoReply/activate`, item)
    return data
  }

  async showMyCallers (item) {
    const data = await Repository.post(`${this.resource}myCallers/show`, item, { params: { page: 0 } })
    return data
  }
}
